import { LeadStatusTypes, Nullable, UUID } from '@cast/leadcast-types';
import { ReplacementInspectionStatus, statusesEligibleForInspection } from 'utils/constants';
import { Geometry, Material, ServiceLineSide } from '..';

export interface ReplacementPoolProperty {
  address: string;
  city: string;
  contractAssignmentId: UUID;
  contractId: UUID;
  contractName: string;
  externalId: string;
  geometry: Geometry;
  leadStatus: LeadStatusTypes['status'] | null;
  postreplacementInspectionStatus: Nullable<ReplacementInspectionStatus>;
  prereplacementInspectionStatus: Nullable<ReplacementInspectionStatus>;
  privateLeadStatus: LeadStatusTypes['status'] | null;
  privateMaterials: Material[];
  propertyId: UUID;
  pwsId: string | null;
  replacementCompletedDate: Nullable<Date>;
  replacementScheduledDate: Nullable<Date>;
  replacementStatus: string;
  roeStatus: string;
  serviceLineSide: ServiceLineSide;
  state: string;
  utilityLeadStatus: LeadStatusTypes['status'] | null;
  utilityMaterials: Material[];
  zipcode: string;
  zone: string;
}

export class ReplacementPoolProperty {
  get isEligibleForPreInspection() {
    if (!this.prereplacementInspectionStatus) return true;
    return statusesEligibleForInspection.some(
      (status) => status === this.prereplacementInspectionStatus
    );
  }

  get isEligibleForPostInspection() {
    if (!this.postreplacementInspectionStatus) return true;
    return statusesEligibleForInspection.some(
      (status) => status === this.postreplacementInspectionStatus
    );
  }
}
